import React, {useEffect, useRef, useState} from 'react'
import {Col, Modal, Row, Spinner} from 'react-bootstrap'
import {createPortal} from 'react-dom'
import axios from 'axios'
import {StepperComponent} from '../../../_metronic/assets/ts/components'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import { SERVER_URL } from '../../ServerConfig'

type Props = {
  show: boolean
  handleClose: () => void
  fileName: any
  loadingFile: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const SellerGstCertificate = ({show, handleClose, fileName, loadingFile}: Props) => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const [fileExists, setFileExists] = useState<boolean | null>(null)
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  useEffect(() => {
    const file = String(fileName || '').trim()
    setErrorMessage('')
    setFileExists(file ? null : false)

    if (!show || !file) {
      setLoading(false)
      return
    }

    const downloadUrl = `${SERVER_URL}/downloads/download?folder_name=buyerSeller&image=${encodeURIComponent(file)}`
    setLoading(true)

    axios
      .get(downloadUrl, {responseType: 'blob'})
      .then(() => {
        setFileExists(true)
      })
      .catch(() => {
        setFileExists(false)
        setErrorMessage('The GST certificate could not be retrieved. Please upload it or contact the administrator for assistance.')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [show, fileName])

  const downloadUrl = `${SERVER_URL}/downloads/download?folder_name=buyerSeller&image=${encodeURIComponent(String(fileName || '').trim())}`

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={handleClose}
      onEntered={loadStepper}
      backdrop={true}
    >
      <div className='modal-header border-bottom border-gray-300 border-bottom-dashed'>
        <h2> GST Certificate </h2>
        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
        {/* end::Close */}
      </div>
      <div className='modal-body p-10'>
        {loading || fileExists === null ? (
          <div className='d-flex align-items-center justify-content-center py-20'>
            <Spinner animation='border' size='sm' className='me-3' />
            <span>Loading GST certificate...</span>
          </div>
        ) : fileExists ? (
          <iframe
            src={downloadUrl}
            frameBorder='0'
            scrolling='auto'
            height='600px'
            width='100%'
            title='GST Certificate'
          />
        ) : (
          <div className='py-20 text-center'>
            <p className='fs-5 mb-3'>
              {String(fileName || '').trim()
                ? errorMessage || 'The GST certificate could not be retrieved. Please upload it or contact the administrator for assistance.'
                : 'No GST certificate has been uploaded yet.'}
            </p>
            {!String(fileName || '').trim() && (
              <p className='text-muted fs-7'>Please upload the document or contact the administrator for assistance.</p>
            )}
          </div>
        )}
      </div>
    </Modal>,
    modalsRoot
  )
}

export default SellerGstCertificate
